import { AxiosInstance } from 'axios';
import {
  EmailBuilderSendDetail,
  EmailBuilderSendSummary,
  RecipientConsentResponse,
  RenderEmailRequest,
  RenderEmailResponse,
  SendEmailRequest,
  SendEmailResponse,
} from '@/api/email-builder/email-builder.types.ts';

export const createEmailBuilderApi = (api: AxiosInstance) => ({
  /** Render the builder draft to HTML for the preview pane. No email is sent. */
  render: (payload: RenderEmailRequest) =>
    api
      .post<RenderEmailResponse>('/v1/email-builder/render', payload)
      .then((res) => res.data),

  /** Dispatches the draft as a one-off email to the supplied recipients. */
  send: (payload: SendEmailRequest) =>
    api
      .post<SendEmailResponse>('/v1/email-builder/send', payload)
      .then((res) => res.data),

  /** Test-sends a single copy of the draft to the calling user. */
  testSend: (payload: RenderEmailRequest) =>
    api
      .post<SendEmailResponse>('/v1/email-builder/test-send', payload)
      .then((res) => res.data),

  /** Contact-employee ids that consented to mail reception (stocklist opt-in). */
  recipientConsent: () =>
    api
      .get<RecipientConsentResponse>('/v1/email-builder/recipient-consent')
      .then((res) => res.data),

  /** Recent send log entries for the caller (newest first, server-capped). */
  listSends: () =>
    api
      .get<EmailBuilderSendSummary[]>('/v1/email-builder/sends')
      .then((res) => res.data),

  getSend: (sendId: number) =>
    api
      .get<EmailBuilderSendDetail>(`/v1/email-builder/sends/${sendId}`)
      .then((res) => res.data),
});
